import { SwiperSlide, Swiper } from "swiper/react";
import { A11y, Navigation } from "swiper";
import { useEffect, useState,useRef } from "react";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { generateSlug } from "@/helpers/slugHelper";
import { useSelector,useDispatch } from "react-redux";
import { showPwaLoader } from "@/redux/actions/pwaAction";

import styles from "../QuickLinksComp/QuickLinks.module.scss";
import { generateBrandOccasionQL } from "@/helpers/pdpHelpers/pdpQLHelper";
export default function QuickLinksComp({breadcrumbList,productDetails,isBundlePresent}) {
    const [quickLinks, setQuickLinks] = useState([]);
    const isMobile = useMediaQuery("(max-width: 767px)");
    const isPWA = useSelector((state) => state.pwa.is_PWA);
    const dispatch = useDispatch();

    const handleClick = (e) => {
      if(isPWA) {
        dispatch(showPwaLoader(true))
      }
    }
    function scrollToNostoCarousel(e) {
      e.preventDefault();
      const targetId = e.currentTarget.getAttribute('href');
      const targetDiv = document.getElementById(targetId);
      if (targetDiv) {
        targetDiv.scrollIntoView({ behavior: 'smooth' });
      }
    }

    // Function to generate the occasion name based on tags and query parameters
    const generateOccassion = async(tags, queryParams) => {
      const params = queryParams ? new URLSearchParams(queryParams) : null; // Parse the query parameters from the URL
            
      let occasionsFromQuery = params ? [...params]?.filter(([key]) => key?.includes("occasionTags"))?.map(([, value]) => decodeURIComponent(value)) : []; // Extract all occasion-related parameters from the query string

      const occasionsFromTags = Array.isArray(tags) ? tags?.filter((tag) => tag?.startsWith("Occasion:"))?.map((tag) => tag.split(":")[1].trim()) : []; // Extract occasion-related tags from the product's tags

      //Extract occasions from query parameters and convert them to an array
      if(occasionsFromQuery.length > 0) {
        occasionsFromQuery = occasionsFromQuery?.toString()?.split(",")
      }
      
      const combinedOccasions = occasionsFromQuery.concat(occasionsFromTags); // Combine both occasions from query parameters and tags into a single array

      //To remove duplicates case-insensitively
      const uniqueOccasions = [];
      const seen = new Set();
      combinedOccasions.forEach(occ => {
        const lower = occ.toLowerCase();
        if (!seen.has(lower)) {
          seen.add(lower);
          uniqueOccasions.push(occ);
        }
      });
      
      return uniqueOccasions || []; // Return unique occasions or an empty array
    }

    // Function to fetch and set quick links based on product details and breadcrumb list
    const getQuickLinks = async() => {
      // Generate a slug for the vendor's short name
      const vendorShortName =  await generateSlug(productDetails.productDetails.vendor);

      // Get the vendor's full name
      const vendorName = productDetails?.productDetails?.vendor;

      // Get the query parameters from the current URL
      const queryParams = window?.location?.search;

      // Generate the occasion name using tags and query parameters
      const occasionNames = await generateOccassion(productDetails.productDetails.tags, queryParams);
      // Generate quick links for category, brand, and occasion using breadcrumb list
      const categoryLinks = breadcrumbList;
      const brandOcassionLinks = generateBrandOccasionQL(categoryLinks, vendorShortName, occasionNames, vendorName);

      // Ensure categoryLinks is not null or undefined
      const safeCategoryLinks = categoryLinks || [];

      // Combine and remove duplicates
      const uniqueQuickLinks = Array.from(
        new Set([...safeCategoryLinks, ...brandOcassionLinks])
      );

      // Update the state with the unique quick links
      setQuickLinks(uniqueQuickLinks);
    }

      const [swiper, setSwiper] = useState();
      const prevRef = useRef();
      const nextRef = useRef();

      const updateTabIndex = () => {
        if(!swiper) return;

        const slides = swiper.slides;
        const lastSlide = slides[slides.length - 1]?.children[0];

        const prevButton = swiper.navigation.prevEl;
        const nextButton = swiper.navigation.nextEl;

        if(lastSlide && document.activeElement === lastSlide){
          if(prevButton) prevButton.tabIndex = -1;
          if(nextButton) nextButton.tabIndex = -1;
        } 
      };

      useEffect(() => {
        if(swiper) {
          swiper.on('slideChange',updateTabIndex);
          swiper.on('transitionEnd',updateTabIndex);
          return () => {
            swiper.off('slideChange',updateTabIndex);
            swiper.off('transitionEnd',updateTabIndex);
          }
        }
      },[swiper]);

      useEffect(() => {
        if (swiper) {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
          swiper.navigation.init();
          swiper.navigation.update();
        }
        //Get quick links
        getQuickLinks();

      }, [swiper,breadcrumbList]);

      const handleKeyDown = (e) =>{
        if(e.key=='Enter'){e?.currentTarget?.querySelector('a')?.click()}
      }
      return (       
        <>
          <div className={`auto-pdp-quicklinks ${styles.wrapper} quick-links-abtest ${isBundlePresent?styles.bundle_spacing:""} ${isMobile ? "pdp-nosto-target" : ""}`}>
            <div className={`${styles.viewMoreLabel}`}>
                <a href="productpage-nosto-2" 
                onClick={scrollToNostoCarousel}
                className="large-md small-xs small-sm cta bordered"><div className={`ga-view-more-ql ${(breadcrumbList[0]?.text)?.trim()}`}>View more</div></a>
            </div>
            <Swiper
            slidesPerView={"auto"}
            speed={500}
            slidesPerGroup={3}
            spaceBetween={20}
            loop={false}
            draggable={true}
            className={`${styles.aa_suggestions_wrapper} ${styles.swiper}`}
            navigation={{
              prevEl: prevRef?.current,
              nextEl: nextRef?.current,
            }}
            modules={[Navigation, A11y]}
            onSwiper={setSwiper}
            >
              {quickLinks?.map((item,index) => (
                <SwiperSlide key={index} className={`${styles.swiper_slide}`}>
                  <div className={styles.aa_suggestions_highlight} tabIndex={0} onKeyDown={(e)=>handleKeyDown(e)}>
                  {/* quick_links_click class is added to track GA quick link event  */}
                  <a onClick={(e) => handleClick(e)} href={item?.link} className={`x-small-xs x-small-sm x-small-md medium quick_links_click`} tabIndex={-1}>{item?.text}</a>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </>
    );
}
